export default __webpack_public_path__ + "static/media/close.19285151.svg";